export function getCommoditiesDescription(axiosPrivate, params){
  return axiosPrivate.post(`/trade-potential/commodities`,params)
}